import http from 'common-module/src/util/http';

/**
 * 获取issue详情
 * @param {*} data
 * @returns
 */
export const getIssueDetail = (data) => {
  return http.post('/issue/get', data);
};

/**
 * 更新issue关联的视频
 * @param {*} data
 * @returns
 */
export const updateIssueVideo = (data) => {
  return http.post('/issue-attachment/update-issue-video', data);
};

/**
 * 更新issue
 * @param {*} data
 * @returns
 */
export const updateIssue = (data) => {
  return http.post('/issue/update', data);
};


